/* eslint-disable */
import Vue from "vue"
import utils from "../../services/utils"
import {
  CHANGE_USER_PASSWORD_REQUEST,
  CHANGE_USER_PASSWORD_SUCCESS,
  CHANGE_USER_PASSWORD_ERROR,
  GET_USER_BALANCE_REQUEST,
  GET_USER_BALANCE_SUCCESS,
  GET_USER_BALANCE_ERROR,
  GET_GAME_VERSION_REQUEST,
  GET_GAME_VERSION_SUCCESS,
  GET_GAME_VERSION_ERROR,
  GET_STATUS_REQUEST,
  GET_STATUS_SUCCESS,
  GET_STATUS_ERROR,
  USER_LOGOUT_REQUEST,
  USER_LOGOUT_SUCCESS,
  USER_LOGOUT_ERROR,

} from "../actions/profile"

import {
  BASE_URL,
  M_POST,
  CHANGE_USER_PASSWORD,
  GET_USER_BALANCE,
  GET_GAME_VERSION,
  GET_STATUS,
  USER_LOGOUT,
} from "../../utils/api"

const state = {
  status: "",
}

const actions = {
  [CHANGE_USER_PASSWORD_REQUEST]: ({commit, dispatch}, user) => {
    return new Promise((resolve, reject) => { // The Promise used for router redirect in login
      commit(CHANGE_USER_PASSWORD_REQUEST)
      Vue.axios({url: BASE_URL + CHANGE_USER_PASSWORD, data: user, method: M_POST })
        .then(resp => {
          let result = resp.data
          if (result.status.code === 0) {
            commit(CHANGE_USER_PASSWORD_SUCCESS)
            resolve(resp)
          } else if (result.status.code === 1002) {
            throw result.status.code
          } else {
            throw result.status.message
          }
        })
        .catch(err => {
          commit(CHANGE_USER_PASSWORD_ERROR, err)
          reject(err)
        })
    })
  },
    [GET_USER_BALANCE_REQUEST]: ({commit, dispatch}, user) => {
      return new Promise((resolve, reject) => { // The Promise used for router redirect in login
        commit(GET_USER_BALANCE_REQUEST)        
        Vue.axios({url: BASE_URL + GET_USER_BALANCE, method: M_POST })
          .then(resp => {
            let result = resp.data
            if (result.status.code === 0) {
              commit(GET_USER_BALANCE_SUCCESS)
              resolve(resp)
            } else if (result.status.code === 1002) {
              throw result.status.code
            } else {
              throw result.status.message
            }
          })
          .catch(err => {
            commit(GET_USER_BALANCE_ERROR, err)
            reject(err)
          })
      })
    },
    [GET_GAME_VERSION_REQUEST]: ({commit, dispatch}, user) => {
      return new Promise((resolve, reject) => { 
        commit(GET_GAME_VERSION_REQUEST)        
        Vue.axios({url: BASE_URL + GET_GAME_VERSION, data: user, method: M_POST })
          .then(resp => {
            let result = resp.data
            if (result.status.code === 0) {
              commit(GET_GAME_VERSION_SUCCESS)
              resolve(resp)
            } else if (result.status.code === 1002) {
              commit(GET_GAME_VERSION_SUCCESS)
              resolve(resp)
            } else {
              throw result.status.message
            }
          })
          .catch(err => {
            commit(GET_GAME_VERSION_ERROR, err)
            reject(err)
          })
      })
    },
    [GET_STATUS_REQUEST]: ({commit}) => {
      return new Promise((resolve, reject) => {
        commit(GET_STATUS_REQUEST)
        Vue.axios({url: BASE_URL + GET_STATUS, method: M_POST})
          .then(resp => {
            let result = resp.data
            if (result.status.code === 0) {
              commit(GET_STATUS_SUCCESS)
              resolve(resp)
            }
            else if(result.status.code === 1002){
              throw result.status.code
            }
            else {
              throw result.status.message
            }
          })
          .catch(err => {
            commit(GET_STATUS_ERROR, err)
            reject(err)
          })
      })
    },
    [USER_LOGOUT_REQUEST]: ({commit, dispatch}, user) => {
      return new Promise((resolve, reject) => { 
        commit(USER_LOGOUT_REQUEST)        
        Vue.axios({url: BASE_URL + USER_LOGOUT, data: user, method: M_POST })
          .then(resp => {
            Vue.prototype.$session.destroy()
            delete Vue.axios.defaults.headers.common['Authorization']
          // localStorage.clear();
            let result = resp.data
            if (result.status.code === 0) {
              // Vue.prototype.$session.destroy()
              // delete Vue.axios.defaults.headers.common['Authorization']
              commit(USER_LOGOUT_SUCCESS)
              resolve(resp)
            } else if (result.status.code === 1002) {
              // Vue.prototype.$session.destroy()
              // delete Vue.axios.defaults.headers.common['Authorization']
              throw result.status.code
            } else {
              throw result.status.message
            }
          })
          .catch(err => {
            commit(USER_LOGOUT_ERROR, err)
            reject(err)
          })
      })
    },
}

const mutations = {
  [CHANGE_USER_PASSWORD_REQUEST]: state => {
    state.status = "loading"
  },
  [CHANGE_USER_PASSWORD_SUCCESS]: state => {
    state.status = "success"
  },
  [CHANGE_USER_PASSWORD_ERROR]: state => {
    state.status = "error"
  },
  [GET_USER_BALANCE_REQUEST]: state => {
    state.status = "loading"
  },
  [GET_USER_BALANCE_SUCCESS]: state => {
    state.status = "success"
  },
  [GET_USER_BALANCE_ERROR]: state => {
    state.status = "error"
  },
  [GET_GAME_VERSION_REQUEST]: state => {
    state.status = "loading"
  },
  [GET_GAME_VERSION_SUCCESS]: state => {
    state.status = "success"
  },
  [GET_GAME_VERSION_ERROR]: state => {
    state.status = "error"
  },
  [GET_STATUS_REQUEST]: state => {
    state.status = "loading"
  },
  [GET_STATUS_SUCCESS]: state => {
    state.status = "success"
  },
  [GET_STATUS_ERROR]: state => {
    state.status = "error"
  },
  [USER_LOGOUT_REQUEST]: state => {
    state.status = "loading"
  },
  [USER_LOGOUT_SUCCESS]: state => {
    state.status = "success"
  },
  [USER_LOGOUT_ERROR]: state => {
    state.status = "error"
  },
}

export default {
  state,
  actions,
  mutations
}
